import { Validators } from '@biteinc/common';
// Keep this aligned with addressSchema from core-react package
export const deliveryAddressSchema = {
    displayName: 'Delivery Address',
    type: 'object',
    fields: {
        line1: {
            displayName: 'Line 1',
            type: 'keyString',
            required: true,
            validationRegex: Validators.addressLineRegex,
        },
        line2: {
            displayName: 'Line 2',
            type: 'keyString',
            validationRegex: Validators.addressLineRegex,
        },
        city: {
            type: 'keyString',
            required: true,
            validationRegex: Validators.simpleStringRegexString({
                allowDiacritics: true,
            }),
        },
        state: {
            type: 'keyString',
            validationRegex: Validators.simpleStringRegexString(),
        },
        postalCode: {
            displayName: 'Postal Code',
            type: 'keyString',
            required: true,
            validationRegex: Validators.postalCodeRegexString,
        },
    },
};
//# sourceMappingURL=delivery_address_schema.js.map